"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKER_EDIT_BUTTON_TITLE = exports.ProposalTracker = exports.CONFLICT_NOT_DRAWN_LABEL = exports.CARD_NOT_DRAWN_LABEL = void 0;
exports.isEditableCard = isEditableCard;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _collisionWording = require("@common/components/remedy/collision-wording");
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _cardCollisions = require("@common/utils/redline/text/card-collisions");
var _checkbox = require("@design/ui/checkbox");
var _cardLiveProposal = require("../proposal-card/card-live-proposal");
var _cardKinds = require("../proposal-card/card-kinds");
var _CardLiveChange = require("../proposal-card/CardLiveChange");
var _ProposalCard = require("../proposal-card/ProposalCard");
var _ProposalCardActions = require("../proposal-card/ProposalCardActions");
var _ChangeThroughoutPlaces = require("../proposal-card/ChangeThroughoutPlaces");
var _ProposalCardContext = require("../proposal-card/ProposalCardContext");
var _LinksNeedingAddressIndicator = require("../proposal-card/LinksNeedingAddressIndicator");
var _locateProposalCard = require("../proposal-card/locate-proposal-card");
var _RemedyPartSupersededIndicator = require("../proposal-card/RemedyPartSupersededIndicator");
var _RevertedInDocumentIndicator = require("../proposal-card/RevertedInDocumentIndicator");
var _WrittenBackIndicator = require("../proposal-card/WrittenBackIndicator");
var _cardCommentSelections = require("../proposal-card/card-comment-selections");
var _AnalyticsContext = require("../../../context/AnalyticsContext");
var _ProposalEditsContext = require("../../../context/ProposalEditsContext");
var _anchorLog = require("../../../utils/anchor/anchor-log");
var _SectionBoundary = require("../../SectionBoundary");
var _cardCommentEntries = require("./card-comment-entries");
var _RowRemovedIndicator = require("../proposal-card/RowRemovedIndicator");
var _CommentTextEditor = require("../proposal-edit/CommentTextEditor");
var _newParagraphTextCard = require("../proposal-edit/new-paragraph-text-card");
var _DocumentPageContext = require("../../../context/DocumentPageContext");
var _useProposalEngineEnabled = require("../../../hooks/use-proposal-engine-enabled");
var _useResetProposalEdit = require("../../../hooks/use-reset-proposal-edit");
var _ConflictResolver = require("./ConflictResolver");
var _DrawnByRender = require("./DrawnByRender");
var _commentPairingStore = require("./comment-pairing-store");
var _paragraphGroups = require("./paragraph-groups");
var _trackerTypes = require("./tracker-types");
var _useFailedCardsNotShown = require("./use-failed-cards-not-shown");
var _WordLikeParagraphGroups = require("./WordLikeParagraphGroups");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var TRACKER_EDIT_BUTTON_TITLE = exports.TRACKER_EDIT_BUTTON_TITLE = "Edit this redline in the chat";
var CARD_NOT_DRAWN_LABEL = exports.CARD_NOT_DRAWN_LABEL = "This card could not be shown, not applied.";
var CONFLICT_NOT_DRAWN_LABEL = exports.CONFLICT_NOT_DRAWN_LABEL = "This conflict could not be shown.";
var asError = function asError(error) {
  return error instanceof Error ? error : new Error(String(error));
};
function reportCardFailure(sendError, failure, action) {
  sendError(asError(failure.error), {
    component: "ProposalTracker",
    action: action,
    actionId: failure.actionId
  });
}
function reportGroupFailure(sendError, group, error, action) {
  sendError(asError(error), {
    component: "ProposalTracker",
    action: action,
    bookmark: group.bookmark
  });
}
var failureReasonsOf = function failureReasonsOf(failures) {
  return new Map(failures.map(function (failure) {
    return [failure.actionId, _anchorLog.AnchorLog.messageOf(failure.error)];
  }));
};
function paragraphGroupsLeavingOutFailingCards(actions, trackerCards, conflictGroups, page) {
  try {
    return {
      groups: (0, _paragraphGroups.paragraphGroupsOf)(actions, trackerCards, conflictGroups, page),
      failures: [],
      unattributedError: null
    };
  } catch (wholeError) {
    var failures = [];
    var actionsKept = [];
    var groups = [];
    var _iterator = _createForOfIteratorHelper(actions),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var action = _step.value;
        try {
          groups = (0, _paragraphGroups.paragraphGroupsOf)([].concat(actionsKept, [action]), trackerCards, conflictGroups, page);
          actionsKept.push(action);
        } catch (error) {
          failures.push({
            actionId: action.id,
            error: error
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var everyCardFailedAlone = actionsKept.length === 0 && actions.length > 1;
    return everyCardFailedAlone ? {
      groups: groups,
      failures: [],
      unattributedError: wholeError
    } : {
      groups: groups,
      failures: failures,
      unattributedError: null
    };
  }
}
function cardCommentEntriesLeavingOutFailingCards(actions, trackerCards, edits) {
  try {
    return {
      entries: (0, _cardCommentEntries.cardCommentEntriesOf)(actions, trackerCards, edits),
      failures: []
    };
  } catch (_unused) {
    var entries = [];
    var failures = [];
    var _iterator2 = _createForOfIteratorHelper(actions),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var action = _step2.value;
        try {
          entries.push.apply(entries, _toConsumableArray((0, _cardCommentEntries.cardCommentEntriesOf)([action], trackerCards, edits)));
        } catch (error) {
          failures.push({
            actionId: action.id,
            error: error
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return {
      entries: entries,
      failures: failures
    };
  }
}
var CardNotDrawn = function CardNotDrawn(_ref) {
  var cardNumber = _ref.cardNumber;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1.5 rounded border border-[#FDE68A] bg-[#FFFDF5] px-2 py-1.5 text-[11px] text-[#92400E]",
    "data-card-not-drawn": cardNumber,
    "data-sentry-component": "CardNotDrawn",
    "data-sentry-source-file": "ProposalTracker.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 13,
      height: 13,
      className: "flex-shrink-0 text-[#F59E0B]",
      "data-sentry-element": "WarningIcon",
      "data-sentry-source-file": "ProposalTracker.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "font-semibold",
      children: ["#", cardNumber]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: CARD_NOT_DRAWN_LABEL
    })]
  });
};
var ConflictNotShown = function ConflictNotShown(_ref2) {
  var onBack = _ref2.onBack;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "h-full flex flex-col gap-2",
    "data-sentry-component": "ConflictNotShown",
    "data-sentry-source-file": "ProposalTracker.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-shrink-0 flex items-center gap-2 pb-1.5 border-b border-[#E5E2DD]",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        onClick: onBack,
        className: "flex items-center gap-1 text-[11px] text-primary bg-transparent border-none p-0 cursor-pointer",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
          width: 12,
          height: 12,
          "data-sentry-element": "ArrowBackIcon",
          "data-sentry-source-file": "ProposalTracker.tsx"
        }), "Back"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[11px] text-[#92400E]",
      children: CONFLICT_NOT_DRAWN_LABEL
    })]
  });
};
function isEditableCard(card) {
  if (card === undefined) return false;
  if (card.content.kind === "comment" || card.content.kind === "reply") return true;
  if (card.content.kind === "paragraph") return (0, _newParagraphTextCard.newParagraphCardIsEditable)(card.content);
  return (0, _trackerTypes.textRedlineOfTrackerCard)(card) !== null;
}
function cardKindOf(action, card) {
  if (card !== undefined) return (0, _cardKinds.cardKindReadingItsPlaces)((0, _cardKinds.proposalCardKindOfContent)(card.content), card.changeThroughoutSelection !== null);
  if (action.type === "comment") return "comment";
  if (action.type === "reply") return "reply";
  if (action.type === "paragraph") return "paragraph";
  return "redline";
}
var iconButtonClass = "flex-shrink-0 p-1 hover:bg-[#E5E2DD] rounded transition-colors bg-transparent border-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed";
var lowestCardNumberOf = function lowestCardNumberOf(group) {
  return Math.min.apply(Math, _toConsumableArray((0, _paragraphGroups.allMembersOf)(group).map(function (member) {
    return member.action.cardNumber;
  })));
};
function byConflictThenDocumentOrder(documentOrder) {
  return function (left, right) {
    var conflictOrder = Number(left.conflict === null) - Number(right.conflict === null);
    if (conflictOrder !== 0) return conflictOrder;
    var leftIndex = documentOrder.get(left.bookmark);
    var rightIndex = documentOrder.get(right.bookmark);
    if (leftIndex !== undefined && rightIndex !== undefined) return leftIndex - rightIndex;
    if (leftIndex !== undefined || rightIndex !== undefined) return leftIndex === undefined ? 1 : -1;
    var sectionOrder = (0, _paragraphGroups.compareSectionNumberKeys)((0, _paragraphGroups.sectionNumberKeyOf)(left.baseText), (0, _paragraphGroups.sectionNumberKeyOf)(right.baseText));
    return sectionOrder !== 0 ? sectionOrder : lowestCardNumberOf(left) - lowestCardNumberOf(right);
  };
}
var ProposalTracker = exports.ProposalTracker = function ProposalTracker(_ref3) {
  var _engineAccess$authorN, _pendingConflicts$fin;
  var actions = _ref3.actions,
    trackerCards = _ref3.trackerCards,
    conflictGroups = _ref3.conflictGroups,
    conversationId = _ref3.conversationId,
    authHeader = _ref3.authHeader,
    isApplying = _ref3.isApplying,
    allUnappliedSelected = _ref3.allUnappliedSelected,
    onToggleSelection = _ref3.onToggleSelection,
    onToggleSelectAll = _ref3.onToggleSelectAll,
    onShowCard = _ref3.onShowCard,
    onGoTo = _ref3.onGoTo,
    onLocateCard = _ref3.onLocateCard,
    onDismiss = _ref3.onDismiss,
    onUndismiss = _ref3.onUndismiss,
    onEditCard = _ref3.onEditCard,
    onResolveOpened = _ref3.onResolveOpened,
    onApplyResolution = _ref3.onApplyResolution,
    onApplyActions = _ref3.onApplyActions;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    openConflictBookmark = _useState2[0],
    setOpenConflictBookmark = _useState2[1];
  var engineAccess = (0, _useProposalEngineEnabled.useProposalEngineAccess)();
  var resetProposalEdit = (0, _useResetProposalEdit.useResetProposalEdit)(conversationId);
  var editAuthorName = (_engineAccess$authorN = engineAccess.authorName) !== null && _engineAccess$authorN !== void 0 ? _engineAccess$authorN : _redlineEngine.DIOPTRA_AUTHOR;
  var signedInAuthorName = engineAccess.signedIn ? editAuthorName : null;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useMemo = (0, _react.useMemo)(function () {
      var previews = new Map();
      var failures = new Map();
      var _iterator3 = _createForOfIteratorHelper(trackerCards.values()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var card = _step3.value;
          try {
            var source = (0, _cardLiveProposal.cardPreviewSourceOfContent)(card.content, card.textRedlineBeforeEdit, card.textRedlineWhenOpened, editAuthorName);
            if (source !== null) previews.set(card.actionId, (0, _cardLiveProposal.cardLivePreviewOf)(source));
          } catch (error) {
            reportCardFailure(sendError, {
              actionId: card.actionId,
              error: error
            }, "preview_card");
            failures.set(card.actionId, _anchorLog.AnchorLog.messageOf(error));
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return {
        previewByActionId: previews,
        previewFailureByActionId: failures
      };
    }, [trackerCards, editAuthorName, sendError]),
    previewByActionId = _useMemo.previewByActionId,
    previewFailureByActionId = _useMemo.previewFailureByActionId;
  var pendingActions = actions.filter(function (action) {
    return !action.isApplied && !action.isDismissed;
  });
  var appliedActions = actions.filter(function (action) {
    return action.isApplied;
  });
  var dismissedActions = actions.filter(function (action) {
    return action.isDismissed;
  });
  var pendingIds = (0, _react.useMemo)(function () {
    return new Set(actions.filter(function (action) {
      return !action.isApplied && !action.isDismissed;
    }).map(function (action) {
      return action.id;
    }));
  }, [actions]);
  var cardBookmarks = (0, _react.useMemo)(function () {
    return Array.from(new Set(Array.from(trackerCards.values()).flatMap(function (card) {
      return (0, _locateProposalCard.bookmarksLocatingProposalCard)(card.content);
    })));
  }, [trackerCards]);
  var page = (0, _DocumentPageContext.useWatchedDocumentPage)(cardBookmarks);
  var pageCoversTheChat = cardBookmarks.every(function (bookmark) {
    return page.coveredBookmarks.has(bookmark);
  });
  var documentHoldsNoneOfTheChat = pageCoversTheChat && cardBookmarks.length > 0 && cardBookmarks.every(function (bookmark) {
    return !page.presentBookmarks.has(bookmark);
  });
  var _useProposalEdits = (0, _ProposalEditsContext.useProposalEdits)(),
    editsOf = _useProposalEdits.editsOf;
  var cardCommentSelectionsVersion = (0, _cardCommentSelections.useCardCommentSelectionsVersion)();
  var _useMemo2 = (0, _react.useMemo)(function () {
      var _cardCommentEntriesLe = cardCommentEntriesLeavingOutFailingCards(actions, trackerCards, editsOf(conversationId)),
        entries = _cardCommentEntriesLe.entries,
        failures = _cardCommentEntriesLe.failures;
      failures.forEach(function (failure) {
        return reportCardFailure(sendError, failure, "read_card_comments");
      });
      return {
        cardCommentEntries: entries,
        commentEntryFailureByActionId: failureReasonsOf(failures)
      };
    }, [actions, trackerCards, editsOf, conversationId, cardCommentSelectionsVersion, sendError]),
    cardCommentEntries = _useMemo2.cardCommentEntries,
    commentEntryFailureByActionId = _useMemo2.commentEntryFailureByActionId;
  var actionsWithCardComments = (0, _react.useMemo)(function () {
    return [].concat(_toConsumableArray(actions), _toConsumableArray(cardCommentEntries.map(function (entry) {
      return entry.action;
    })));
  }, [actions, cardCommentEntries]);
  var trackerCardsWithCardComments = (0, _react.useMemo)(function () {
    return new Map([].concat(_toConsumableArray(trackerCards), _toConsumableArray(cardCommentEntries.map(function (entry) {
      return [entry.action.id, entry.card];
    }))));
  }, [trackerCards, cardCommentEntries]);
  var pendingIdsWithCardComments = (0, _react.useMemo)(function () {
    return new Set([].concat(_toConsumableArray(pendingIds), _toConsumableArray(cardCommentEntries.filter(function (entry) {
      return !entry.action.isApplied;
    }).map(function (entry) {
      return entry.action.id;
    }))));
  }, [pendingIds, cardCommentEntries]);
  var _useMemo3 = (0, _react.useMemo)(function () {
      var _paragraphGroupsLeavi = paragraphGroupsLeavingOutFailingCards(actionsWithCardComments, trackerCardsWithCardComments, conflictGroups, page),
        groups = _paragraphGroupsLeavi.groups,
        failures = _paragraphGroupsLeavi.failures,
        unattributedError = _paragraphGroupsLeavi.unattributedError;
      failures.forEach(function (failure) {
        return reportCardFailure(sendError, failure, "group_cards");
      });
      if (unattributedError !== null) sendError(asError(unattributedError), {
        component: "ProposalTracker",
        action: "group_cards"
      });
      return {
        groupsBeforePairing: groups.filter(function (group) {
          return (0, _paragraphGroups.memberActionIdsOf)(group).some(function (actionId) {
            return pendingIds.has(actionId);
          });
        }),
        groupingFailureByActionId: failureReasonsOf(failures)
      };
    }, [actionsWithCardComments, trackerCardsWithCardComments, conflictGroups, page, pendingIds, sendError]),
    groupsBeforePairing = _useMemo3.groupsBeforePairing,
    groupingFailureByActionId = _useMemo3.groupingFailureByActionId;
  var pendingPairings = (0, _react.useMemo)(function () {
    return groupsBeforePairing.flatMap(function (group) {
      try {
        var pending = (0, _paragraphGroups.commentPairingRequestOf)(group);
        return pending === null ? [] : [pending];
      } catch (error) {
        reportGroupFailure(sendError, group, error, "request_comment_pairing");
        return [];
      }
    });
  }, [groupsBeforePairing, sendError]);
  var pairings = (0, _commentPairingStore.useCommentPairings)(authHeader, pendingPairings);
  var shownGroups = (0, _react.useMemo)(function () {
    var groupsPaired = groupsBeforePairing.map(function (group) {
      try {
        var key = (0, _paragraphGroups.commentPairingKeyOf)(group);
        return key === null ? group : (0, _paragraphGroups.withCommentPairings)(group, pairings.answerFor(key));
      } catch (error) {
        reportGroupFailure(sendError, group, error, "pair_comments");
        return group;
      }
    });
    try {
      return groupsPaired.sort(byConflictThenDocumentOrder(page.documentOrder));
    } catch (error) {
      sendError(asError(error), {
        component: "ProposalTracker",
        action: "order_groups"
      });
      return groupsPaired;
    }
  }, [groupsBeforePairing, pairings, page.documentOrder, sendError]);
  var cardFailureByActionId = (0, _react.useMemo)(function () {
    return new Map([].concat(_toConsumableArray(previewFailureByActionId), _toConsumableArray(commentEntryFailureByActionId), _toConsumableArray(groupingFailureByActionId)).filter(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        actionId = _ref5[0];
      return !(0, _cardCommentSelections.isCardCommentKey)(actionId);
    }));
  }, [previewFailureByActionId, commentEntryFailureByActionId, groupingFailureByActionId]);
  (0, _useFailedCardsNotShown.useFailedCardsNotShown)(cardFailureByActionId, "tracker_cards");
  var heldBackReasonOf = function heldBackReasonOf(action) {
    var _action$heldBackReaso;
    return (_action$heldBackReaso = action.heldBackReason) !== null && _action$heldBackReaso !== void 0 ? _action$heldBackReaso : cardFailureByActionId.get(action.id);
  };
  var idsInGroups = new Set(shownGroups.flatMap(_paragraphGroups.memberActionIdsOf));
  var pendingConflicts = shownGroups.flatMap(function (group) {
    return group.conflict === null ? [] : [group.conflict];
  });
  var openConflict = (_pendingConflicts$fin = pendingConflicts.find(function (conflict) {
    return conflict.group.bookmark === openConflictBookmark;
  })) !== null && _pendingConflicts$fin !== void 0 ? _pendingConflicts$fin : null;
  function toggleCardOrItsComment(id) {
    if ((0, _cardCommentSelections.isCardCommentKey)(id)) {
      _cardCommentSelections.cardCommentSelections.toggle(id);
      return;
    }
    onToggleSelection(id);
  }
  function dismissCardOrLeaveOutItsComment(id) {
    if ((0, _cardCommentSelections.isCardCommentKey)(id)) {
      _cardCommentSelections.cardCommentSelections.setChecked(id, false);
      return;
    }
    onDismiss(id);
  }
  function showCardOrTheCardOfItsComment(id) {
    if ((0, _cardCommentSelections.isCardCommentKey)(id)) {
      onShowCard((0, _cardCommentSelections.cardIdOfCardCommentKey)(id));
      return;
    }
    onShowCard(id);
  }
  function applyCardsWithoutTheirComments(ids) {
    onApplyActions(ids.filter(function (id) {
      return !(0, _cardCommentSelections.isCardCommentKey)(id);
    }));
  }
  var openResolver = function openResolver(conflict) {
    setOpenConflictBookmark(conflict.group.bookmark);
    onResolveOpened(conflict);
  };
  var applyResolution = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(conflict, composedText, decisions) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return onApplyResolution(conflict, composedText, decisions);
          case 1:
            setOpenConflictBookmark(null);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function applyResolution(_x, _x2, _x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  function conflictingPairsOf(conflict) {
    var collisionCards = conflict.cards.flatMap(function (card) {
      var textRedline = (0, _trackerTypes.textRedlineOfTrackerCard)(card);
      return textRedline === null ? [] : [{
        cardId: card.actionId,
        paragraphs: (0, _cardCollisions.collisionParagraphsOf)(textRedline)
      }];
    });
    return (0, _cardCollisions.potentialCollisionsOfCards)(collisionCards).filter(function (collision) {
      return (0, _cardCollisions.proximityNeedsChoice)(collision.proximity);
    });
  }
  function changeThroughoutConflictsOfRow(action) {
    var collisionLinks = conflictGroups.flatMap(function (conflict) {
      var numberOf = new Map(conflict.cards.map(function (card) {
        return [card.actionId, card.cardNumber];
      }));
      return conflictingPairsOf(conflict).filter(function (collision) {
        return collision.cardId === action.id;
      }).flatMap(function (collision) {
        var otherCardNumber = numberOf.get(collision.otherCardId);
        if (otherCardNumber === undefined) return [];
        return [{
          number: otherCardNumber,
          proximity: collision.proximity,
          onShow: function onShow() {
            return onShowCard(collision.otherCardId);
          }
        }];
      });
    });
    return (0, _ChangeThroughoutPlaces.changeThroughoutConflictsOf)(action.cardNumber, collisionLinks);
  }
  function conflictSummariesOf(conflict) {
    var numberOf = new Map(conflict.cards.map(function (card) {
      return [card.actionId, card.cardNumber];
    }));
    var conflictingPairs = conflictingPairsOf(conflict);
    var clusters = [];
    var _iterator4 = _createForOfIteratorHelper(conflictingPairs),
      _step4;
    try {
      var _loop = function _loop() {
        var collision = _step4.value;
        var touching = clusters.filter(function (cluster) {
          return cluster.proximity === collision.proximity && (cluster.cardIds.has(collision.cardId) || cluster.cardIds.has(collision.otherCardId));
        });
        var merged = {
          proximity: collision.proximity,
          cardIds: new Set([collision.cardId, collision.otherCardId].concat(_toConsumableArray(touching.flatMap(function (cluster) {
            return Array.from(cluster.cardIds);
          }))))
        };
        touching.forEach(function (cluster) {
          return clusters.splice(clusters.indexOf(cluster), 1);
        });
        clusters.push(merged);
      };
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return clusters.map(function (cluster) {
      return (0, _collisionWording.groupSummaryOf)(Array.from(cluster.cardIds).map(function (cardId) {
        var _numberOf$get;
        return (_numberOf$get = numberOf.get(cardId)) !== null && _numberOf$get !== void 0 ? _numberOf$get : 0;
      }).sort(function (left, right) {
        return left - right;
      }), cluster.proximity);
    });
  }
  function renderCheckbox(checked, onToggle, label, disabled) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
      checked: checked,
      onCheckedChange: onToggle,
      "aria-label": label,
      disabled: disabled,
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      "data-sentry-element": "Checkbox",
      "data-sentry-component": "renderCheckbox",
      "data-sentry-source-file": "ProposalTracker.tsx"
    });
  }
  function renderCardContent(card, action, rowState) {
    if (card === undefined) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[11px] text-[#686766]",
      children: action.description
    });
    if (card.changeThroughoutSelection !== null) return null;
    var content = card.content;
    if (content.kind === "comment" || content.kind === "reply") {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "text-[11px] text-[#4a5568] whitespace-pre-wrap",
        children: (0, _CommentTextEditor.commentTextWithUserChanges)(content.text, card.textBeforeEdit, editAuthorName)
      });
    }
    var preview = previewByActionId.get(card.actionId);
    if (preview === undefined) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardLiveChange.CardLiveChange, {
      preview: preview,
      signedInAuthorName: signedInAuthorName,
      blockLimit: _cardLiveProposal.CARD_EXCERPT_BLOCK_LIMIT,
      applied: rowState === "applied",
      "data-sentry-element": "CardLiveChange",
      "data-sentry-component": "renderCardContent",
      "data-sentry-source-file": "ProposalTracker.tsx"
    });
  }
  function renderRowStatus(action) {
    if (action.isRefused) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "flex items-center gap-1 flex-shrink-0 text-[11px] text-[#A81E36] font-medium",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 12,
          height: 12
        }), "Not applied"]
      });
    }
    if (action.failureReason) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyFailedIndicator, {
      reason: action.failureReason,
      partlyApplied: Boolean(action.isPartiallyApplied)
    });
    if (action.revertedInDocument) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RevertedInDocumentIndicator.RevertedInDocumentIndicator, {});
    var heldBackReason = heldBackReasonOf(action);
    if (heldBackReason !== undefined) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "flex items-center gap-1 flex-shrink-0 text-[11px] text-[#92400E] font-medium",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 12,
          height: 12
        }), heldBackReason]
      });
    }
    return null;
  }
  function renderGoToButton(bookmarks, actionIds) {
    if (bookmarks.length === 0) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: function onClick(event) {
        event.stopPropagation();
        onGoTo(bookmarks, actionIds);
      },
      className: "flex-shrink-0 bg-transparent border-none p-0 text-[11px] text-primary cursor-pointer hover:underline",
      title: "Go to this place in the document",
      "data-sentry-component": "renderGoToButton",
      "data-sentry-source-file": "ProposalTracker.tsx",
      children: "Locate"
    });
  }
  function renderLocateCardButton(card) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: function onClick(event) {
        event.stopPropagation();
        onLocateCard(card);
      },
      className: "flex-shrink-0 bg-transparent border-none p-0 text-[11px] text-primary cursor-pointer hover:underline",
      "data-sentry-component": "renderLocateCardButton",
      "data-sentry-source-file": "ProposalTracker.tsx",
      children: "Locate"
    });
  }
  function renderRowLead(action, rowState) {
    if (rowState === "applied") return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "flex-shrink-0 w-4 h-4 flex items-center justify-center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
        width: 14,
        height: 14,
        className: "text-[#10B981]"
      })
    });
    if (rowState === "dismissed") return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "flex-shrink-0 w-4 h-4 flex items-center justify-center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
        width: 13,
        height: 13,
        className: "text-[#686766]"
      })
    });
    var alreadyInDocument = Boolean(action.documentAlreadyReadsAsProposed);
    var heldBack = heldBackReasonOf(action) !== undefined;
    return renderCheckbox(action.isSelected && !alreadyInDocument, function () {
      return onToggleSelection(action.id);
    }, "Select #".concat(action.cardNumber), Boolean(action.isPartiallyApplied) || alreadyInDocument || heldBack);
  }
  function renderCardContext(card, action, rowState) {
    if (card === undefined) return null;
    return (0, _ChangeThroughoutPlaces.cardContextWithChangeThroughoutPlaces)((0, _ProposalCardContext.proposalCardContextOf)(card.content, action.id), card.changeThroughoutSelection, {
      actionId: action.id,
      cardState: rowState,
      summaryLine: "aboveThePlaces",
      conflicts: changeThroughoutConflictsOfRow(action)
    });
  }
  function renderRowStatusOf(action, rowState) {
    if (rowState === "applied" && action.supersededBy) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedySupersededIndicator, {
      supersededBy: action.supersededBy,
      onShowSuperseder: null
    });
    if (rowState === "applied" && action.partSupersededBy) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyPartSupersededIndicator.RemedyPartSupersededIndicator, {
      partSupersededBy: action.partSupersededBy
    });
    if (action.rowRemovedBy !== undefined && rowState === "pending" && !action.isRefused && !action.failureReason) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RowRemovedIndicator.RowRemovedIndicator, {
        removedBy: action.rowRemovedBy
      });
    }
    if (rowState === "applied" && action.writtenBack && action.failureReason) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrittenBackIndicator.WrittenBackIndicator, {
      writtenBackReason: action.failureReason
    });
    if (rowState === "applied" && action.partlyRevertedInDocument) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RevertedInDocumentIndicator.PartlyRevertedInDocumentIndicator, {});
    if (rowState === "applied") return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyAppliedIndicator, {});
    if (rowState === "dismissed") return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[11px] text-[#686766] font-medium",
      children: "Dismissed"
    });
    return renderRowStatus(action);
  }
  function renderRowTrailing(action, card, rowState) {
    if (rowState === "dismissed") {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: function onClick(event) {
          event.stopPropagation();
          onUndismiss(action.id);
        },
        disabled: action.isDismissalSaving,
        "aria-busy": action.isDismissalSaving || undefined,
        className: iconButtonClass,
        title: "Undo dismiss",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyIconOrSpinner, {
          isSaving: Boolean(action.isDismissalSaving),
          icon: _materialSymbols.UndoIcon,
          size: 13,
          className: "text-[#686766]"
        })
      });
    }
    var locateButton = card === undefined ? null : renderLocateCardButton(card);
    var editButton = rowState === "pending" && isEditableCard(card) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: function onClick(event) {
        event.stopPropagation();
        onEditCard(action.id);
      },
      className: iconButtonClass,
      title: TRACKER_EDIT_BUTTON_TITLE,
      "aria-label": TRACKER_EDIT_BUTTON_TITLE,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
        width: 13,
        height: 13,
        className: "text-[#686766]"
      })
    }) : null;
    var resetButton = rowState === "pending" && card !== undefined && (0, _trackerTypes.trackerCardHasUserEdit)(card) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: function onClick(event) {
        event.stopPropagation();
        resetProposalEdit(action.id, cardKindOf(action, card), "drawer");
      },
      className: iconButtonClass,
      title: _ProposalCardActions.RESET_TO_AGENT_VERSION_LABEL,
      "aria-label": _ProposalCardActions.RESET_TO_AGENT_VERSION_LABEL,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UndoIcon, {
        width: 13,
        height: 13,
        className: "text-[#686766]"
      })
    }) : null;
    var dismissButton = rowState === "pending" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      onClick: function onClick(event) {
        event.stopPropagation();
        onDismiss(action.id);
      },
      disabled: action.isDismissalSaving,
      "aria-busy": action.isDismissalSaving || undefined,
      className: iconButtonClass,
      title: "Dismiss",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyIconOrSpinner, {
        isSaving: Boolean(action.isDismissalSaving),
        icon: _materialSymbols.CloseIcon,
        size: 13,
        className: "text-[#686766]"
      })
    }) : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [locateButton, editButton, resetButton, dismissButton]
    });
  }
  function toneOf(action, rowState) {
    if (rowState === "applied") return "applied";
    if (rowState === "dismissed") return "dismissed";
    var failedWhole = Boolean(action.failureReason) && !action.isPartiallyApplied;
    return action.isRefused || failedWhole ? "problem" : "default";
  }
  function renderLinksNeedingAddressOfRow(card, rowState) {
    if (card === undefined || rowState === "dismissed") return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinksNeedingAddressIndicator.LinksNeedingAddressIndicator, {
      linksNeedingAddress: (0, _LinksNeedingAddressIndicator.linksNeedingAddressOf)((0, _trackerTypes.textRedlineOfTrackerCard)(card)),
      density: "drawerRow",
      "data-sentry-element": "LinksNeedingAddressIndicator",
      "data-sentry-component": "renderLinksNeedingAddressOfRow",
      "data-sentry-source-file": "ProposalTracker.tsx"
    });
  }
  function renderCardRowBody(action, card, rowState) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalCard.ProposalCard, {
      identity: {
        cardNumber: action.cardNumber,
        kind: cardKindOf(action, card)
      },
      density: "tracker",
      tone: toneOf(action, rowState),
      leading: renderRowLead(action, rowState),
      status: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [renderRowStatusOf(action, rowState), renderLinksNeedingAddressOfRow(card, rowState)]
      }),
      controls: renderRowTrailing(action, card, rowState),
      content: renderCardContent(card, action, rowState),
      context: renderCardContext(card, action, rowState),
      onOpen: function onOpen() {
        return onShowCard(action.id);
      },
      "data-sentry-element": "ProposalCard",
      "data-sentry-component": "renderCardRowBody",
      "data-sentry-source-file": "ProposalTracker.tsx"
    });
  }
  function renderCardRow(action, rowState) {
    var card = trackerCards.get(action.id);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionBoundary.SectionBoundary, {
      section: "apply_all_row",
      cardActionIds: [action.id],
      resetKeys: [rowState, card === undefined, card !== undefined && (0, _trackerTypes.trackerCardHasUserEdit)(card), previewByActionId.has(action.id), page.readStartedAtMs],
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(CardNotDrawn, {
        cardNumber: action.cardNumber
      }),
      "data-sentry-element": "SectionBoundary",
      "data-sentry-component": "renderCardRow",
      "data-sentry-source-file": "ProposalTracker.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DrawnByRender.DrawnByRender, {
        draw: function draw() {
          return renderCardRowBody(action, card, rowState);
        },
        "data-sentry-element": "DrawnByRender",
        "data-sentry-source-file": "ProposalTracker.tsx"
      })
    }, action.id);
  }
  var selectAllRow = pendingActions.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex-shrink-0 flex items-center gap-2 px-2 pb-1.5 border-b border-[#E5E2DD]",
    children: [renderCheckbox(allUnappliedSelected, onToggleSelectAll, "Select all", false), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "text-xs font-medium text-[#4a5568]",
      children: ["Select all (", pendingActions.length, ")"]
    })]
  }) : null;
  function renderSectionHeader(label, count) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "text-[11px] font-medium text-[#686766] px-1",
      "data-sentry-component": "renderSectionHeader",
      "data-sentry-source-file": "ProposalTracker.tsx",
      children: [label, " (", count, ")"]
    });
  }
  var groupViewProps = {
    groups: shownGroups,
    pendingIds: pendingIdsWithCardComments,
    conversationId: conversationId,
    renderGoToButton: renderGoToButton,
    conflictSummariesOf: conflictSummariesOf,
    onOpenResolver: openResolver,
    onShowCard: showCardOrTheCardOfItsComment,
    onEditCard: onEditCard,
    onDismiss: dismissCardOrLeaveOutItsComment,
    onToggleSelection: toggleCardOrItsComment,
    onApplyActions: applyCardsWithoutTheirComments,
    tablePackagesByGroup: page.tablePackageByGroupKey
  };
  var groupsSection = shownGroups.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1.5",
    children: [renderSectionHeader("By paragraph", shownGroups.length), /*#__PURE__*/(0, _jsxRuntime.jsx)(_WordLikeParagraphGroups.WordLikeParagraphGroups, _objectSpread({}, groupViewProps))]
  }) : null;
  var pendingActionsOutsideGroups = pendingActions.filter(function (action) {
    return !idsInGroups.has(action.id);
  });
  var pendingSection = pendingActionsOutsideGroups.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1",
    children: [renderSectionHeader("Pending", pendingActionsOutsideGroups.length), pendingActionsOutsideGroups.map(function (action) {
      return renderCardRow(action, "pending");
    })]
  }) : null;
  var appliedActionsOutsideGroups = appliedActions.filter(function (action) {
    return !idsInGroups.has(action.id);
  });
  var appliedSection = appliedActionsOutsideGroups.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1",
    children: [renderSectionHeader("Applied", appliedActionsOutsideGroups.length), appliedActionsOutsideGroups.map(function (action) {
      return renderCardRow(action, "applied");
    })]
  }) : null;
  var dismissedSection = dismissedActions.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1 border-t border-[#E5E2DD] pt-1.5",
    children: [renderSectionHeader("Dismissed", dismissedActions.length), dismissedActions.map(function (action) {
      return renderCardRow(action, "dismissed");
    })]
  }) : null;
  if (openConflict !== null) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionBoundary.SectionBoundary, {
      section: "conflict_resolver",
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(ConflictNotShown, {
        onBack: function onBack() {
          return setOpenConflictBookmark(null);
        }
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConflictResolver.ConflictResolver, {
        conflict: openConflict,
        isApplying: isApplying,
        previewOf: function previewOf(actionId) {
          var _previewByActionId$ge;
          return (_previewByActionId$ge = previewByActionId.get(actionId)) !== null && _previewByActionId$ge !== void 0 ? _previewByActionId$ge : null;
        },
        signedInAuthorName: signedInAuthorName,
        onBack: function onBack() {
          return setOpenConflictBookmark(null);
        },
        onApply: function onApply(composedText, decisions) {
          return void applyResolution(openConflict, composedText, decisions);
        }
      })
    }, openConflict.group.bookmark);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "h-full flex flex-col gap-1.5",
    "data-sentry-component": "ProposalTracker",
    "data-sentry-source-file": "ProposalTracker.tsx",
    children: [selectAllRow, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-1 min-h-0 overflow-y-auto flex flex-col gap-1.5 focus-ring-room",
      children: [documentHoldsNoneOfTheChat && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-start gap-1.5 rounded border border-[#F59E0B] bg-[#FFFBEB] px-2 py-1.5 text-[11px] text-[#92400E]",
        role: "status",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 13,
          height: 13,
          className: "flex-shrink-0 mt-px"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "None of this chat's paragraphs are in the open document. This looks like a different copy of the file, so nothing here can be previewed or applied until the document the chat was run on is open."
        })]
      }), page.readError !== null && !pageCoversTheChat && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-start gap-1.5 rounded border border-[#F59E0B] bg-[#FFFBEB] px-2 py-1.5 text-[11px] text-[#92400E]",
        role: "status",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 13,
          height: 13,
          className: "flex-shrink-0 mt-px"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          children: ["Word did not answer when the document was read (", page.readError, "). Trying again."]
        })]
      }), groupsSection, pendingSection, appliedSection, dismissedSection]
    })]
  });
};